var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter10420361({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "printer_1042036 1",
    clipPath: "url(#clip0_4182_2424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2256 1.03247H6.77413C6.57726 1.03247 6.41769 1.19208 6.41769 1.38891V9.28867C6.41769 9.48546 6.57726 9.64507 6.77413 9.64507C6.97101 9.64507 7.13057 9.48546 7.13057 9.28863V1.74535H18.8692V9.28863C18.8692 9.48546 19.0288 9.64507 19.2256 9.64507C19.4225 9.64507 19.5821 9.48546 19.5821 9.28863V1.38891C19.5821 1.19208 19.4225 1.03247 19.2256 1.03247Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1907 16.9531H20.6753C20.8721 16.9531 21.0317 16.7935 21.0317 16.5967C21.0317 16.3998 20.8721 16.2402 20.6753 16.2402H5.32445C5.12758 16.2402 4.96802 16.3998 4.96802 16.5967C4.96802 16.7935 5.12758 16.9531 5.32445 16.9531H6.809L6.07447 23.8033C6.05352 23.9991 6.19513 24.1747 6.39083 24.1957C6.58766 24.2169 6.76222 24.075 6.78322 23.8794L7.52591 16.9532H18.4737L19.2567 24.2546H6.74296L6.79138 23.8033C6.81238 23.6076 6.67077 23.4319 6.47502 23.4109C6.27983 23.39 6.10363 23.5316 6.08263 23.7273L5.99192 24.5731C5.9811 24.6736 6.01358 24.7741 6.08117 24.8493C6.14881 24.9246 6.24519 24.9675 6.3463 24.9675H19.6535C19.7546 24.9675 19.851 24.9245 19.9186 24.8493C19.9862 24.7741 20.0187 24.6737 20.0079 24.5731L19.1907 16.9531Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.7465 9.04663H3.322C2.04166 9.04663 1 10.0883 1 11.3687V19.3138C1 20.5942 2.04166 21.6359 3.322 21.6359H6.51519C6.71206 21.6359 6.87162 21.4763 6.87162 21.2795C6.87162 21.0826 6.71206 20.923 6.51523 20.923H3.322C2.4347 20.923 1.71288 20.2011 1.71288 19.3138V11.3687C1.71288 10.4814 2.43475 9.75951 3.322 9.75951H21.7465C21.9434 9.75951 22.103 9.5999 22.103 9.40307C22.103 9.20624 21.9434 9.04663 21.7465 9.04663Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.6775 9.04663H21.9347C21.7378 9.04663 21.5783 9.20624 21.5783 9.40307C21.5783 9.5999 21.7378 9.75951 21.9347 9.75951H22.6775C23.5651 9.75951 24.2871 10.4814 24.2871 11.3687V19.3138C24.2871 20.2011 23.565 20.923 22.6775 20.923H19.4843C19.2874 20.923 19.1279 21.0826 19.1279 21.2795C19.1279 21.4763 19.2874 21.6359 19.4843 21.6359H22.6775C23.9581 21.6359 25 20.5942 25 19.3138V11.3687C25 10.0883 23.9581 9.04663 22.6775 9.04663Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.7941 14.5596H5.20596C5.00908 14.5596 4.84952 14.7192 4.84952 14.916V18.718C4.84952 18.9148 5.00908 19.0744 5.20596 19.0744H6.78992C6.9868 19.0744 7.14636 18.9148 7.14636 18.718C7.14636 18.5212 6.9868 18.3616 6.78992 18.3616H5.56239V15.2724H20.4377V18.3616H19.2101C19.0133 18.3616 18.8537 18.5212 18.8537 18.718C18.8537 18.9148 19.0133 19.0744 19.2101 19.0744H20.7941C20.991 19.0744 21.1505 18.9148 21.1505 18.718V14.916C21.1505 14.7191 20.991 14.5596 20.7941 14.5596Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.06536 10.52C3.18748 10.52 2.4733 11.2342 2.4733 12.1121C2.4733 12.99 3.18748 13.7041 4.06536 13.7041C4.94323 13.7041 5.65742 12.99 5.65742 12.1121C5.65742 11.2342 4.94323 10.52 4.06536 10.52ZM4.06536 12.9913C3.58058 12.9913 3.18617 12.5969 3.18617 12.1121C3.18617 11.6273 3.58058 11.2329 4.06536 11.2329C4.55014 11.2329 4.94455 11.6273 4.94455 12.1121C4.94455 12.5969 4.55014 12.9913 4.06536 12.9913Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.77227 10.52C6.89439 10.52 6.18021 11.2342 6.18021 12.1121C6.18021 12.99 6.89439 13.7041 7.77227 13.7041C8.65014 13.7041 9.36433 12.99 9.36433 12.1121C9.36438 11.2342 8.65014 10.52 7.77227 10.52ZM7.77227 12.9913C7.28749 12.9913 6.89308 12.5969 6.89308 12.1121C6.89308 11.6273 7.28749 11.2329 7.77227 11.2329C8.25705 11.2329 8.65146 11.6273 8.65146 12.1121C8.65146 12.5969 8.2571 12.9913 7.77227 12.9913Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.6335 22.1636H8.3662C8.16933 22.1636 8.00977 22.3232 8.00977 22.52C8.00977 22.7168 8.16933 22.8764 8.3662 22.8764H17.6335C17.8304 22.8764 17.99 22.7168 17.99 22.52C17.99 22.3232 17.8304 22.1636 17.6335 22.1636Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.4079 20.5476H8.59185C8.39502 20.5476 8.23541 20.7072 8.23541 20.904C8.23541 21.1009 8.39498 21.2605 8.59185 21.2605H17.4078C17.6047 21.2605 17.7643 21.1009 17.7643 20.904C17.7643 20.7072 17.6047 20.5476 17.4079 20.5476Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.2177 18.9319H8.78197C8.5851 18.9319 8.42554 19.0915 8.42554 19.2883C8.42554 19.4852 8.5851 19.6448 8.78197 19.6448H17.2177C17.4146 19.6448 17.5742 19.4852 17.5742 19.2883C17.5742 19.0915 17.4147 18.9319 17.2177 18.9319Z",
    fill: "#62D862",
    stroke: "#62D862",
    strokeWidth: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4182_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter10420361);
export default __webpack_public_path__ + "static/media/printer_1042036_1.ff82a53f3ec52eba8555948a5f336e6d.svg";
export { ForwardRef as ReactComponent };